<template>
  <v-card>
    <v-text-field label="Image URL" v-model="localCard.image"></v-text-field>
    <v-text-field label="Annotation URL" v-model="localCard.annotation"></v-text-field>
    <v-text-field label="Description" v-model="localCard.description"></v-text-field>
    <v-card v-for="(entry, key) in localCard.entries" :key="key">
      <v-layout row wrap>
        <v-flex xs1>

        </v-flex>
        <v-flex xs3>
          <v-text-field v-model="entry.label"></v-text-field>
        </v-flex>
        <v-flex xs6>
          <v-text-field v-model="entry.string"></v-text-field>
        </v-flex>
      </v-layout>

    </v-card>
    <v-card>
      <v-layout row wrap>
        <v-flex xs1>

        </v-flex>
        <v-flex xs3>
          <v-text-field label="Label" v-model="newEntry.label"></v-text-field>
        </v-flex>
        <v-flex xs6>
          <v-text-field label="String" v-model="newEntry.string"></v-text-field>
        </v-flex>
        <v-flex xs2>
          <v-btn icon @click="addEntry()" :disabled="newEntry.string == null || newEntry.label == null">
            <v-icon>
              mdi-plus
            </v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
      {{localCard}}

    </v-card>

    <v-btn absolute right class="ma-3" color="orange" dark v-if="!card" @click="saveCard">Save Card</v-btn>
    <v-btn absolute right class="ma-3" color="blue" dark v-if="card" @click="editCard">Edit Card</v-btn>
  </v-card>


</template>

<script>

import obj from '@/objects'

export default {
  name: 'CardTypeLabledImage',
  props: ['card'],
  components: {

  },
  watch: {
    card() {
      this.setCard()
    }
  },
  data() {
    return {
      localCard: null,
      newEntry: this.createEntry()
    }
  },
  created() {
    this.setCard()
  },
  methods: {
    createEntry() {
      return {label: null, string: null}
    },
    addEntry() {
      this.localCard.entries.push(this.newEntry)
      //this.localCard.entries.push(this.newEntry)
      this.newEntry = this.createEntry()

    },
    setCard() {
      if (this.card != null) {
        this.localCard = this.card
      }
      else {
        this.localCard = obj.createNewCard('labeled_image')
      }

    },
    saveCard() {
      console.log('saveCard', this.localCard)
      this.$emit('saveCard', this.localCard)
    },
    editCard() {
      this.$emit('editCard', this.localCard)
    },
  }
}
</script>

<style>

</style>
